import { cn } from '@crossnokaye/ux-common';

import { State } from '@repo/sdk/models/components';

import { useShutdownBanner } from '@/hooks/query-hooks/gaia-api/shutdown-banner';
import { useCurrentFacility } from '@/hooks/use-current-facility';

import { ShutdownBanner } from './shutdown-banner/shutdown-banner';

export const Banner = () => {
  const { agentId } = useCurrentFacility();
  const { data: shutdownStatus } = useShutdownBanner(agentId);

  // Only show banner if there's actual shutdown data (not idle/null)
  const shouldShowBanner = shutdownStatus && shutdownStatus.state !== State.Idle;

  return (
    <div
      id={'shutdown-banner-container'}
      className={cn(
        'transition-all duration-500 ease-in',
        shouldShowBanner ? 'opacity-100' : 'opacity-0'
      )}
    >
      {shouldShowBanner && <ShutdownBanner />}
    </div>
  );
};
